import { UnknownAction } from 'redux';
import { Account } from '@commutifi-fe/interfaces';
import { LoginBody } from 'api/modules/authentication';
import { DeconstructedPromiseType } from 'shared/interfaces/utils';
import * as types from './types';
export interface PasswordFormValues {
  email: string;
  password: string;
}
interface LogoutOptions {
  error?: string;
  currentAccountId?: string;
}
export interface LogoutAction<T = void> extends UnknownAction {
  type: typeof types.LOGOUT;
  payload?: LogoutOptions;
  promise?: DeconstructedPromiseType<T>;
}
export interface LogoutSuccessAction extends UnknownAction {
  type: typeof types.LOGOUT_SUCCESS;
  payload?: LogoutOptions;
}
export interface LoginAction<T = void> extends UnknownAction {
  type: typeof types.LOGIN_REQUEST;
  auth: LoginBody;
  options: {
    stayLoggedIn?: boolean;
  };
  promise?: DeconstructedPromiseType<T>;
}
export interface LoginSuccessAction<T = Partial<Account>> extends UnknownAction {
  type: typeof types.LOGIN_SUCCESS;
  account: Partial<Account>;
  options: {
    stayLoggedIn?: boolean;
  };
  promise?: DeconstructedPromiseType<T>;
}
export interface LoginFailureAction extends UnknownAction {
  type: typeof types.LOGIN_FAILURE;
  error: any;
  messageKey?: string;
}
export interface UnauthorizedUserAction extends UnknownAction {
  type: typeof types.UNAUTHORIZE_USER;
  payload?: LogoutOptions;
}
export interface ClearUserAction extends UnknownAction {
  type: typeof types.CLEAR_USER;
}

/*
 * LOGIN
 */
export const loginSuccess = <T = void,>(account: Partial<Account>, options: {
  stayLoggedIn?: boolean;
}, promise?: DeconstructedPromiseType<T>): LoginSuccessAction<T> => ({
  type: types.LOGIN_SUCCESS,
  account,
  options,
  promise
});
export const loginFailure = (error: any): LoginFailureAction => ({
  type: types.LOGIN_FAILURE,
  error
});
export const loginRequest = <T = void,>(auth: LoginBody, options: {
  stayLoggedIn?: boolean;
}, promise?: DeconstructedPromiseType<T>): LoginAction<T> => ({
  type: types.LOGIN_REQUEST,
  auth,
  options,
  promise
});

/*
 * LOGOUT
 */
export const logout = <T = void,>(options?: LogoutOptions | React.MouseEvent, promise?: DeconstructedPromiseType<T>): LogoutAction<T> => ({
  type: types.LOGOUT,
  // This check is to avoid passing click events to the logout params since logout could be used directly
  // in an onClick event without really knowing the impact. Instead of risking for the issue to come back we simply do the check here
  payload: (Object.prototype.hasOwnProperty.call(options || {}, 'target') ? undefined : options) as LogoutOptions | undefined,
  promise
});
export const logoutSuccess = (payload?: LogoutOptions): LogoutSuccessAction => ({
  type: types.LOGOUT_SUCCESS,
  payload
});
export const unauthorizeUser = (options?: LogoutOptions): UnauthorizedUserAction => ({
  type: types.UNAUTHORIZE_USER,
  payload: options
});
export const clearUser = (): ClearUserAction => ({
  type: types.CLEAR_USER
});
export type AuthActionType = LoginAction<any> | LoginSuccessAction<any> | LoginFailureAction | LogoutAction<any> | LogoutSuccessAction | UnauthorizedUserAction | ClearUserAction;